import { render, staticRenderFns } from "./modalBuscarConvenio.vue?vue&type=template&id=223c0e80&"
import script from "./modalBuscarConvenio.vue?vue&type=script&lang=js&"
export * from "./modalBuscarConvenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports